import { render, staticRenderFns } from "./SheetsPage.vue?vue&type=template&id=fb715762"
import script from "./SheetsPage.vue?vue&type=script&lang=js"
export * from "./SheetsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports